module.exports = __webpack_public_path__ + "static/img/guide_1_1_3.de55af6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_1_1_3.jpg
// module id = bou+
// module chunks = 1